// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"oj_a bhn_a bhn_x","FilterForm__vgroup":"oj_b bhn_sv"};